import { ChangeDetectionStrategy, Component, effect, input } from '@angular/core';
import { BaseMessageComponent } from './base-message.component';
import { DefaultTableSelectionHandler, TABLE_SELECTOR_HANDLER, TableComponent } from '@cbre/components';

@Component({
  selector: 'miq-table',
  template: `
    <p class="summary">{{ summary }}</p>

    <div class="table-container">
      <cbre-table
        [elements]="rowData"
        [columns]="columns"
        [pageSize]="10"
        [pageSizeOptions]="[10, 20, 50, 100]"
        maxHeight="600px"
        [stickyHeader]="true"
      ></cbre-table>
    </div>
  `,
  styles: [
    `
      .summary {
        font-size: 14px;
        margin-bottom: 10px;
      }
      .table-container ::ng-deep.mat-mdc-paginator-container {
        flex-wrap: nowrap !important;
        .mat-mdc-paginator-range-label {
          margin-right: 0 !important;
          margin-left: 17px !important;
        }
      }
    `,
  ],
  providers: [{ provide: TABLE_SELECTOR_HANDLER, useClass: DefaultTableSelectionHandler }],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TableComponent],
})
export class ChatTableComponent implements BaseMessageComponent {
  readonly content = input<Record<string, any>>();

  columns: Record<string, any>[] = [];
  rowData: Record<string, any>[] = [];
  summary = '';

  constructor() {
    effect(() => {
      const value = this.content();
      if (value) {
        this.summary = value.summary || '';
        if (value.columns && value.rows?.length > 0) {
          this.columns = this._buildColumns(value.columns);
          this.rowData = value.rows.map(row =>
            value.columns.reduce((acc: Record<string, any>, key: string, index: number) => {
              acc[key] = row[index];
              return acc;
            }, {})
          );
        } else {
          this.columns = [];
          this.rowData = [];
        }
      }
    });
  }

  private _buildColumns(keys: string[]): Record<string, any>[] {
    return keys.map(key => ({
      field: key,
      header: this.formatHeader(key),
    }));
  }

  private formatHeader(key: string): string {
    // Convert keys like 'AREA_LEASED' to 'Area Leased'
    return key
      .toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase());
  }
}
